import { useGetLicenses } from "@/hooks/useGetLicenses/useGetLicenses";
import { useHasLineWithLanguages } from "@/hooks/useHasLineWithLanguages/useHasLineWithLanguages";
import { useCcAccess } from "../useCcAccess/useCcAccess";

export const useShouldDisplayPromotionalBanner = () => {
  const { hasLine, loading: lineLoading } = useHasLineWithLanguages({
    languages: ["en-*", "fr-*", "es-*", "it-*", "nl-*", "de-*"],
  });
  const { canRead } = useCcAccess();
  const { hasLicense, loading: licensesLoading } = useGetLicenses();
  const hasAiStandardAccess =
    hasLicense("aircall_ai") || hasLicense("ai_assist_pro");

  return (
    !lineLoading &&
    !licensesLoading &&
    canRead &&
    hasLine &&
    !hasAiStandardAccess
  );
};
